<template>
  <div class="main-container">
    <!-- 左右布局 -->
    <div class="content-wrapper">
      <!-- 品牌管理 -->
      <div class="brand-section">
        <h3>品牌管理</h3>
        <!-- 上传按钮 -->
        <el-upload
            class="upload-button"
            accept=".txt"
            action=""
            :auto-upload="false"
            :on-change="handleBrandUpload"
        >
          <el-button type="primary" size="small">上传品牌文件</el-button>
        </el-upload>

        <!-- 搜索框 -->
        <el-input
            v-model="brandSearch"
            placeholder="搜索品牌"
            class="search-input"
            clearable
            @input="filterBrand"
        ></el-input>

        <!-- 品牌表格 -->
        <el-table :data="filteredBrandList" border stripe height="700px">
          <el-table-column label="序号" width="80">
            <template #default="{ $index }">
              {{ $index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="brand" label="品牌名称"></el-table-column>
          <el-table-column label="操作" width="180">
            <template #default="{ row }">
              <el-button size="small" type="danger" @click="deleteBrand(row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 品牌表单 -->
        <el-form :model="brandForm" label-width="80px" class="form">
          <el-form-item label="品牌名称">
            <el-input v-model="brandForm.brand" placeholder="请输入品牌"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="saveBrand">保存</el-button>
            <el-button @click="resetBrandForm">重置</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 违禁词管理 -->
      <div class="forbidden-section">
        <h3>违禁词管理</h3>
        <!-- 上传按钮 -->
        <el-upload
            class="upload-button"
            accept=".txt"
            action=""
            :auto-upload="false"
            :on-change="handleForbiddenUpload"
        >
          <el-button type="primary" size="small">上传违禁词文件</el-button>
        </el-upload>

        <!-- 搜索框 -->
        <el-input
            v-model="forbiddenSearch"
            placeholder="搜索违禁词"
            class="search-input"
            clearable
            @input="filterForbidden"
        ></el-input>

        <!-- 违禁词表格 -->
        <el-table :data="filteredForbiddenList" border stripe height="700px">
          <el-table-column label="序号" width="80">
            <template #default="{ $index }">
              {{ $index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="forbiddenWord" label="违禁词"></el-table-column>
          <el-table-column label="操作" width="180">
            <template #default="{ row }">
              <el-button size="small" type="danger" @click="deleteForbidden(row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 违禁词表单 -->
        <el-form :model="forbiddenForm" label-width="80px" class="form">
          <el-form-item label="违禁词">
            <el-input v-model="forbiddenForm.forbiddenWord" placeholder="请输入违禁词"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="saveForbidden">保存</el-button>
            <el-button @click="resetForbiddenForm">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 品牌列表
      brandList: [
      ],
      brandSearch: "",
      filteredBrandList: [],

      // 品牌表单
      brandForm: { brand: "" },

      // 违禁词列表
      forbiddenList: [

      ],
      forbiddenSearch: "",
      filteredForbiddenList: [],

      // 违禁词表单
      forbiddenForm: { forbiddenWord: "" },
    };
  },
  created() {
    this.filteredBrandList = [...this.brandList];
    this.filteredForbiddenList = [...this.forbiddenList];

    // 在组件挂载后发起请求查询数据库
    this.fetchBrandList();
    this.fetchWeijinciList();

  },

  methods: {

    // 查询品牌列表
    fetchBrandList() {
      return this.$axios.get("/sys/weijinci/getbrands")
          .then(res => {
            if (res.data && res.data.data) {
              this.brandList = res.data.data; // 更新品牌列表
              this.filteredBrandList = [...this.brandList]; // 初始化过滤列表
            }
          })
          .catch(error => {
            this.$message.error("获取品牌数据失败！");
          });
    },

    fetchWeijinciList() {
      return this.$axios.get("/sys/weijinci/getweijinci")
          .then(res => {
            if (res.data && res.data.data) {
              this.forbiddenList = res.data.data; // 更新品牌列表
              this.filteredForbiddenList = [...this.forbiddenList]; // 初始化过滤列表
            }
          })
          .catch(error => {
            this.$message.error("获取违禁词数据失败！");
          });
    },
    // 品牌操作
    saveBrand() {
      const brand = this.brandForm.brand;
      if (typeof brand !== "string" || brand.trim().length === 0) {
        this.$message.warning("品牌名称不能为空！");
        return;
      }

      // 检查品牌是否已存在
      const exists = this.brandList.some(
          (item) => item.brand === brand
      );
      if (exists) {
        this.$message.error("该品牌已存在！");
        return;
      }

      // 2. 向后端发送删除请求
      this.$axios.post('/sys/weijinci/addbrand', this.brandForm)
          .then(response => {
            this.brandList.push({...this.brandForm});
            this.filterBrand(); // 更新搜索结果
            this.resetBrandForm();
            this.$message.success("品牌添加成功！");
          })
          .catch(error => {
            this.$message.error("品牌添加失败！");
          });

    },

    deleteBrand(row) {
      // 1. 从本地的 brandList 中移除品牌
      const index = this.brandList.findIndex(item => item.brand === row.brand);
      if (index !== -1) {
        this.brandList.splice(index, 1);  // 删除对应的品牌
        this.filterBrand();  // 更新过滤后的列表
      }

      // 2. 向后端发送删除请求
      this.$axios.post('/sys/weijinci/deletebrand', { brand: row.brand })
          .then(response => {
            // 删除成功后，通知用户
            this.$message.success("品牌删除成功！");
          })
          .catch(error => {
            // 如果删除失败，恢复本地列表
            this.fetchBrandList();  // 重新获取品牌列表
            this.$message.error("品牌删除失败！");
          });
    },
    // 品牌上传处理
    handleBrandUpload(file) {
      const reader = new FileReader();
      reader.onload = async (event) => {
        const lines = event.target.result.split("\n");
        const newBrands = [];

        lines.forEach((line) => {
          const trimmedLine = line.trim();
          if (trimmedLine && !this.brandList.some((item) => item.brand === trimmedLine)) {
            newBrands.push({ brand: trimmedLine });
          }
        });

        if (newBrands.length > 0) {
          this.brandList.push(...newBrands); // 添加新的品牌到品牌列表
          this.filterBrand(); // 更新搜索结果

          // 发送新品牌数据到后端
          try {
            await this.$axios.post('sys/weijinci/uploadbrands', { brands: newBrands });
            this.$message.success("品牌文件上传并保存成功！");
          } catch (error) {
            await this.fetchBrandList();
            this.$message.error("品牌上传失败！");
          }
        } else {
          this.$message.info("上传的品牌已全部存在，未做任何更新！");
        }
      };
      reader.readAsText(file.raw);
    },


    // 违禁词操作
    saveForbidden() {
      const forbiddenWord = this.forbiddenForm.forbiddenWord;
      if (typeof forbiddenWord !== "string" || forbiddenWord.trim().length === 0) {
        this.$message.warning("违禁词不能为空！");
        return;
      }

      // 检查违禁词是否已存在
      const exists = this.forbiddenList.some(
          (item) => item.forbiddenWord === forbiddenWord
      );
      if (exists) {
        this.$message.error("该违禁词已存在！");
        return;
      }

      // 2. 向后端发送删除请求
      this.$axios.post('/sys/weijinci/addforbiddenWord', this.forbiddenForm)
          .then(response => {
            this.forbiddenList.push({...this.forbiddenForm});
            this.filterForbidden(); // 更新搜索结果
            this.resetForbiddenForm();
            this.$message.success("违禁词添加成功！");
          })
          .catch(error => {
            this.$message.error("违禁词添加失败！");
          });

    },
    deleteForbidden(row) {
      // 1. 从本地的 forbiddenList 中移除违禁词
      const index = this.forbiddenList.findIndex(item => item.forbiddenWord === row.forbiddenWord);
      if (index !== -1) {
        this.forbiddenList.splice(index, 1);  // 删除对应的违禁词
        this.filterForbidden();  // 更新过滤后的列表
      }

      // 2. 向后端发送删除请求
      this.$axios.post('/sys/weijinci/deleteweijinci', { forbiddenWord: row.forbiddenWord })
          .then(response => {
            // 删除成功后，通知用户
            this.$message.success("违禁词删除成功！");
          })
          .catch(error => {
            // 如果删除失败，恢复本地列表
            this.fetchWeijinciList();  // 重新获取违禁词列表
            this.$message.error("违禁词删除失败！");
          });
    },
    // 违禁词上传处理
    handleForbiddenUpload(file) {
      const reader = new FileReader();
      reader.onload = async (event) => {
        const lines = event.target.result.split("\n");
        const newForbiddenWords = [];

        lines.forEach((line) => {
          const trimmedLine = line.trim();
          if (trimmedLine && !this.forbiddenList.some((item) => item.forbiddenWord === trimmedLine)) {
            newForbiddenWords.push({ forbiddenWord: trimmedLine });
          }
        });

        if (newForbiddenWords.length > 0) {
          this.forbiddenList.push(...newForbiddenWords); // 添加新的违禁词到违禁词列表
          this.filterForbidden(); // 更新搜索结果

          // 发送新违禁词数据到后端
          try {
            await this.$axios.post('sys/weijinci/uploadweijinci', { forbiddenWords: newForbiddenWords });
            this.$message.success("违禁词文件上传并保存成功！");
          } catch (error) {
            await this.fetchWeijinciList();
            this.$message.error("违禁词上传失败！");
          }
        } else {
          this.$message.info("上传的违禁词已全部存在，未做任何更新！");
        }
      };
      reader.readAsText(file.raw);
    },

    // 搜索过滤
    filterBrand() {
      this.filteredBrandList = this.brandList.filter((item) =>
          item.brand.includes(this.brandSearch)
      );
    },
    filterForbidden() {
      this.filteredForbiddenList = this.forbiddenList.filter((item) =>
          item.forbiddenWord.includes(this.forbiddenSearch)
      );
    },

    // 重置表单
    resetBrandForm() {
      this.brandForm = {brand: ""};
    },
    resetForbiddenForm() {
      this.forbiddenForm = {forbiddenWord: ""};
    },
  },
};
</script>

<style scoped>
.main-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
  background: #f5f7fa;
}

.content-wrapper {
  display: flex;
  gap: 20px;
}

.brand-section,
.forbidden-section {
  flex: 1;
  padding: 20px;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 4px;
}

.search-input {
  margin-bottom: 10px;
}

.upload-button {
  margin-bottom: 10px;
}
</style>
